'use strict';

/**
 * 打开新窗口，winphone不支持打开新窗口
 * @param  {[type]} openUrl [description]
 * @return {[type]}         [description]
 */

var openIframe = require('./open_iframe');
var isIOS = require('./is_ios');
function rejectOpen(entrys, entry) {
  var i = 0;
  var n = entrys.length;
  for (i = 0; i < n; i++) {
    if (entry.indexOf(entrys[i]) >= 0) {
      return true;
    }
  }
  return false;
}

module.exports = function (openUrl, rejectOpenWindow) {

  // 如果是scheme协议的唤起，则使用iframe的形式进行唤起
  var openUrlArray = openUrl.split('://');
  var schemeType = openUrlArray[0];
  if (schemeType === 'http' || schemeType === 'https' || openUrlArray.length === 1) {
    var net = require('@ali/network');
    var ua = window.navigator.userAgent.toLowerCase();
    var host = window.location.host || '';
    var querystring = window.location.search;
    var entrys = rejectOpenWindow || [];
    entrys.push('bmsg_');
    var entry = net.query('entry') || '';

    // 配置的不开窗口渠道，
    // 比如UC browser中的信息流不能开窗口
    // 以及兼容IOS 非Browser的异步之后新开窗口
    // 自有业务模式也不打开新窗口
    if (rejectOpen(entrys, entry) || isIOS() && ua.indexOf('ucbrowser') < 0 || querystring.indexOf('uc_biz_str') >= 0) {
      setTimeout(function () {
        window.location.href = openUrl;
      }, 100);
      return;
    }

    // 开发阶段使用的hack
    if (net.query('dev') === 'true') {
      window.open(openUrl);
      return;
    }

    if (ua.indexOf('iemobile/9') >= 0 || ua.indexOf('iemobile/10') >= 0 || ua.indexOf('iemobile/11') >= 0) {
      // 兼容win phone 不能新开窗口，不能强制刷新当前页面
      window.open(openUrl);
    } else if (ua.indexOf('ucbrowser') >= 0 && host.indexOf('ucweb.com') >= 0) {
      // UC 下，而且是 ucweb.com 这个域名下，才用 ext
      var extOpenUrl = 'ext:wo:' + openUrl;
      window.location.href = extOpenUrl;
    } else {
      window.open(openUrl);
    }
  } else {
    openIframe(openUrl);
  }
};